// extracted by mini-css-extract-plugin
module.exports = {"container":"TransactionsPageTemplate_container__r2FYa","bannerWrapper":"TransactionsPageTemplate_bannerWrapper__SCFao"};